module.exports = __webpack_public_path__ + "static/media/rotary-phones-1280.d4c4337b.jpg";